<template lang="pug">
v-dialog(v-model="show", persistent, max-width="50%")
  v-card
    v-card-title.title Faturas do Período
    v-card-text
      faturasList(ref="faturasList", @showFatura="showFaturaDetail")
    v-card-actions.mr-4.pb-3
        v-spacer
        v-btn(flat,@click="close()") Fechar

</template>

<script>

import faturasList from '@/pages/financeiro/fatura/Faturas';

export default {
  components: {
    faturasList,
  },
  props: {
    showFatura: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data () {
    return {
        show : false,
        fatura : null
    }
  },
  created () {

  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(faturas){
      const vm = this;
      vm.$refs.faturasList.refresh(faturas)
      vm.show = true;
    },
    close(){
      const vm = this;
      vm.show = false;
    },
    showFaturaDetail(fatura){
      const vm = this;
      vm.$emit('showFatura', fatura);
    },
  }
}
</script>
